export const roundToTwoDecimals = <T extends number>(num: T): T => {
  if (Number.isNaN(num) || !Number.isFinite(num)) {
    return 0 as T // Handle NaN or Infinity
  }
  return (Math.round((num + Number.EPSILON) * 100) / 100) as T
}

export const roundCredits = (num: number): number => {
  if (Number.isNaN(num) || !Number.isFinite(num)) {
    return 0 // Handle NaN or Infinity
  }
  // Fix floating point error by rounding to 6 decimals before ceil
  const fixed = Math.round(num * 1e6) / 1e6
  return Math.ceil(fixed)
}
